export const ACTION_TYPE = {
  LINK: 'LINK',
  CUSTOM: 'CUSTOM',
  OPEN_MODAL_PANEL: 'OPEN_MODAL_PANEL',
  OPEN_COMPONENT_PANEL: 'OPEN_COMPONENT_PANEL',
  SELECT_TAB: 'SELECT_TAB'
}
